import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { Staleness, StalenessReason } from "@/lib/annotation.server";

const REASON_COPY: Record<StalenessReason, string> = {
  new_sources: "New annotation sources have been added since this ran.",
  admixture_pending: "You've opted into ancestry estimates since this ran.",
  haplogroup_pending: "You've opted into haplogroup calling since this ran.",
};

/** Compact pill + inline button, for a dashboard job card. */
export function StalenessRow({
  staleness,
  onReprocess,
  pending,
}: {
  staleness: Staleness;
  onReprocess: () => void;
  pending: boolean;
}) {
  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 rounded-2xl bg-primary/8 p-3">
      <span className="inline-flex items-center gap-2 rounded-full bg-primary/12 px-3 py-1 text-xs font-semibold text-primary">
        <RefreshCw className="size-3" /> Update available
      </span>
      <p className="text-sm text-muted-foreground">
        {staleness.reasons.map((reason) => REASON_COPY[reason]).join(" ")}
      </p>
      <Button size="sm" variant="outline" onClick={onReprocess} disabled={pending}>
        Reprocess this sample
      </Button>
    </div>
  );
}

/** Larger callout, for the report page. */
export function StalenessCallout({
  staleness,
  onReprocess,
  pending,
}: {
  staleness: Staleness;
  onReprocess: () => void;
  pending: boolean;
}) {
  return (
    <section className="mt-8 rounded-3xl border border-primary/30 bg-primary/8 p-6">
      <h2 className="flex items-center gap-2 text-xl">
        <RefreshCw className="size-5 text-primary" /> Update available
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
        {staleness.reasons.map((reason) => REASON_COPY[reason]).join(" ")} Reprocessing runs your
        file through the pipeline again and replaces these results.
      </p>
      <Button className="mt-4" onClick={onReprocess} disabled={pending}>
        Reprocess this sample
      </Button>
    </section>
  );
}
